
$models.folderstatuses = {
	
	getItem : function() { },
	
	getList : function($params, $callback) {
		$models.all.getDataFromAPI('folder_statuses.json', $params, $callback, 'Unable to retrieve folder statuses.  You might not have permission to do so.');
	},
	
	getSize : function() { },
	
	setItem : function($id, $formData, $callback) {
		if ($id && (parseInt($id) > 0)) {
			$models.all.getDataFromAPI('folder_statuses/'+parseInt($id)+'.json', $formData, $callback, 'An error occurred whilst saving the folder status', 'PUT');
		} else {
			$models.all.getDataFromAPI('folder_statuses.json', $formData, $callback, 'An error occurred whilst saving the folder status', 'POST');
		}
	},
	
	deleteItem : function($id, $callback) {
		$models.all.getDataFromAPI('folder_statuses/'+parseInt($id)+'.json', '', $callback, 'Cannot delete folder status because it is currently in use.', 'DELETE');
	}
	
};



// WEBPACK FOOTER //
// ./src/js/models/folderstatuses.js